module.exports = __webpack_public_path__ + "media/images/calendar-198ca9199d858b199df4e05aa4c5657f.svg";